import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Login template
 */
export class LoginComponent {
  @Input() formGroup!: UntypedFormGroup;
  @Output() clickSubmit = new EventEmitter<any>();

  /**
   * Action to take when submit button is clicked
   */
  onSubmit() {
    this.clickSubmit.emit();
  }
}
